import AppForm from "components/AppForm/AppForm";
import CrudPage from "components/CrudPage/CrudPage";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import withRouter from "hoc/withRouter";
import { useLoadAll } from "hooks/useLoadAll";
import inputTypeEnum from "enums/inputTypes";
import { snack } from "components/Snack/Snack";
import counterpartiesService from "services/admin/counterpartiesService";

interface CounterpartyFormProps {
  router: any;
  data: any;
}

const CounterpartyForm = ({ router, data }: CounterpartyFormProps) => {
  const {
    navigate,
    params: { id },
  } = router;
  const { counterparty } = data;

  const fieldsWithData = [
    {
      key: "name",
      label: "Наименование юр. лица",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "bin",
      label: "БИН/ИИН",
      inputType: inputTypeEnum.text,
    },
    {
      key: "contactPerson",
      label: "Контактное лицо",
      inputType: inputTypeEnum.text,
    },
    {
      key: "phone",
      label: "Телефон",
      inputType: inputTypeEnum.text,
    },
    {
      key: "email",
      label: "Email",
      inputType: inputTypeEnum.email,
    },
    {
      key: "address",
      label: "Адрес",
      inputType: inputTypeEnum.text,
    },
    {
      key: "contractNumber",
      label: "Номер договора (необязательно)",
      inputType: inputTypeEnum.text,
    },
    {
      key: "contractDate",
      label: "Дата договора (необязательно)",
      inputType: inputTypeEnum.date,
      allowEmpty: true,
    },
    {
      key: "note",
      label: "Примечание",
      inputType: inputTypeEnum.text,
    },
    {
      key: "isActive",
      label: "Активен",
      inputType: inputTypeEnum.checkbox,
      defaultValue: true,
    },
  ];

  const onSubmit = async (formValues: any) => {
    // Договорные реквизиты опциональны: пустые значения шлём как null.
    const payload = {
      ...formValues,
      contractNumber: formValues.contractNumber?.trim() || null,
      contractDate: formValues.contractDate || null,
    };
    try {
      if (counterparty) {
        await counterpartiesService.put(id, payload);
        snack("Контрагент обновлён успешно!");
      } else {
        await counterpartiesService.post(payload);
        snack("Контрагент создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex);
    }
  };

  return (
    <CrudPage title={counterparty ? "Редактирование контрагента" : "Создание контрагента"}>
      <AppForm onSubmit={onSubmit} data={counterparty} fields={fieldsWithData}></AppForm>
    </CrudPage>
  );
};
export default withRouter(
  withRemoteDataAndSpinner(CounterpartyForm, (router: any) => {
    let requests: any = {};
    if (router.params.id) {
      requests["counterparty"] = () => counterpartiesService.get(router.params.id);
    }
    return useLoadAll(requests);
  }),
);
